import { AccessFormField } from '../../../ClearVerifyStaffAccessFormPart/constants';

export const FormFields = {
  status: 'status',
  ...AccessFormField,
} as const;
